export default __webpack_public_path__ + "img/sagoo/sagoo1_480.webp";